<template>
  <div class="footBox ">
    <div class="ICP-centent text-center">
        Copyright © {{new Date().getFullYear()}} shenyinhudong.com All rights reserved.
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a class="ICP-url" href="http://beian.miit.gov.cn/">京ICP备14038000号-16</a>
        <!-- &nbsp;&nbsp;&nbsp;&nbsp;
        <a class="ICP-url" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502038891">京公网安备 11010502038891号</a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
}
</script>

<style scoped lang="scss">
  .footBox{
    background: #000;
    .ICP-centent{
      width:1200px;
      margin:auto;
      line-height: 54px;
      color: #454751;
      .ICP-url{
        color: #454751;
      }
    }
  }
</style>
